<template>
  <div class="stripe-container">
    <div v-if="licenca == null" class="text-center py-5">
      <div
        :class="carregandoAssinaturas ? 'spinner-border text-primary' : 'bi bi-arrow-clockwise'"
        style="cursor: pointer; font-size: 2.5rem; color: #0d6efd;"
        role="status"
        @click="inicializar"
      />
      <p class="mt-3 text-muted">
        {{ $t('carregando') }}
      </p>
    </div>

    <div v-if="licenca != null" class="container-fluid">
      <div class="row">
        <div class="col-lg-8 mx-auto">
          <div class="card border-0 shadow-sm mb-0 bg-light">
            <div class="card-body py-3 px-4">
              <h5 class="mb-2 text-primary fw-bold">
                {{ textoAssinatura }}
              </h5>
              <div class="row g-4 mt-1">
                <div class="col-md-6 border-end">
                  <small class="text-muted d-block">{{ $t('status') }}</small>
                  <p class="mb-0 small mt-1">
                    {{ textoStatusAssinatura }}
                  </p>
                </div>
                <div class="col-md-6">
                  <small class="text-muted d-block">{{ $t('qtdOSFeitasNesseMes') }}</small>
                  <p class="mb-0 small mt-1 fw-bold">
                    {{ licenca.quantidadeOsCriada }} OSs
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="textoInformeAssinaturaDuplicada.length > 0" class="alert alert-warning border-0 shadow-sm mb-4">
            <i class="bi bi-exclamation-triangle-fill" />
            {{ textoInformeAssinaturaDuplicada }}
          </div>

          <div class="row justify-content-center mb-4">
            <div class="col-lg-6">
              <LoadingButton
                v-if="!(assinaturas.length > 0) && textoInformeAssinaturaDuplicada.length == 0"
                class="btn btn-lg btn-primary w-100"
                :loading="carregando"
                @click="assinarGerenciar"
              >
                <i class="bi bi-cash-coin" />
                {{ temAssinaturaStripe ? $t('gerenciarAssinatura') : $t('assinar') }}
              </LoadingButton>
            </div>
          </div>

          <div v-if="assinaturas.length > 0" class="card border-0 shadow-sm bg-light py-3 px-4">
            <h5 class="mb-3 text-primary fw-bold">
              <i class="bi bi-sliders" />
              {{ $t('personalizarAssinatura') }}
            </h5>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label fw-bold">
                  <i class="bi bi-people-fill text-info" />
                  {{ $t('quantidadeUsuarios') }}
                </label>
                <select v-model="quantidadeUsuariosSelecionada" class="form-select">
                  <option v-for="opcao in opcoesUsuarios" :key="opcao" :value="opcao">
                    {{ opcao }} {{ $t('usuario', opcao) }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label fw-bold">
                  <i class="bi bi-calendar-event text-info" />
                  {{ $t('duracaoMeses') }}
                </label>
                <select v-model="quantidadeMesesSelecionada" class="form-select">
                  <option v-for="opcao in opcoesMeses" :key="opcao" :value="opcao">
                    {{ opcao === 1 ? `${opcao} ${$t('mes', opcao)}` : $t('mes', opcao) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-8 mx-auto">
          <div v-if="assinaturas.length > 0">
            <div v-if="construindoCheckout" class="text-center py-4">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status" />
              <p class="mt-3 text-muted">
                {{ $t('preparandoCheckout') }}
              </p>
            </div>
            <div
              v-show="!construindoCheckout"
              id="checkout"
              class="stripe-checkout-wrapper"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { getCheckoutSession, getAssinaturas, getCustomerPortal, obterLicenca } from '../stripeService';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { toDate } from '@/modules/core/utils/formats';
import NomeAssinatura from '@/modules/shared/NomeAssinatura';
import { useToast } from 'vue-toastification';
import secret from '@/config/stripe.json';
export default {
  components: { LoadingButton },
  data() {
    return {
      stripe: null,
      clientSecret: null,
      checkout: null,
      assinaturas: [],
      quantidadeUsuariosSelecionada: null,
      quantidadeMesesSelecionada: null,
      opcoesUsuarios: [],
      opcoesMeses: [],
      carregando: false,
      carregandoAssinaturas: true,
      customerPortalUrl: null,
      temAssinaturaStripe: false,
      licenca: null,
      textoStatusAssinatura: '',
      textoAssinatura: '',
      textoQtdOSFeitasNesseMes: '',
      textoInformeAssinaturaDuplicada: '',
      construindoCheckout: false,
    };
  },
  computed: {
    priceSelecionado() {
      if (!this.quantidadeUsuariosSelecionada || !this.quantidadeMesesSelecionada) {
        return null;
      }
      return this.assinaturas.find((price) => {
        const maxUsers = parseInt(price.metadata?.max_users);
        const durationMonths = parseInt(price.metadata?.duration_months);
        return maxUsers === this.quantidadeUsuariosSelecionada &&
               durationMonths === this.quantidadeMesesSelecionada;
      });
    },
  },
  watch: {
    priceSelecionado: {
      async handler(newVal) {
        if (newVal) {
          await this.remountCheckout();
        }
      },
    },
  },
  async mounted() {
    this.inicializar();
  },
  unmounted() {
    this.unmountCheckout();
  },
  methods: {
    async assinarGerenciar() {
      if (this.temAssinaturaStripe) {
        this.carregando = true;
        this.customerPortalUrl = await getCustomerPortal();
        window.location.href = this.customerPortalUrl;
      } else {
        this.carregando = true;
        await this.getAssinaturas();
        await this.mountCheckout();
        this.carregando = false;
      }
    },
    async remountCheckout() {
      this.unmountCheckout();
      await this.mountCheckout();
    },
    async getAssinaturas() {
      try {
        this.assinaturas = await getAssinaturas();
        if (this.assinaturas && this.assinaturas.length > 0) {
          const usuariosSet = new Set();
          const mesesSet = new Set();

          this.assinaturas.forEach((price) => {
            if (price.metadata?.max_users) {
              usuariosSet.add(parseInt(price.metadata.max_users));
            }
            if (price.metadata?.duration_months) {
              mesesSet.add(parseInt(price.metadata.duration_months));
            }
          });

          this.opcoesUsuarios = Array.from(usuariosSet).sort((a, b) => a - b);
          this.opcoesMeses = Array.from(mesesSet).sort((a, b) => a - b);

          if (this.opcoesUsuarios.length > 0) {
            this.quantidadeUsuariosSelecionada = this.opcoesUsuarios[0];
          }
          if (this.opcoesMeses.length > 0) {
            this.quantidadeMesesSelecionada = this.opcoesMeses[0];
          }
        }
      } catch (error) {
        this.assinaturas = [];
        this.toastErro();
      }
    },
    async mountCheckout() {
      if (this.assinaturas.length > 0 && this.priceSelecionado && !this.construindoCheckout) {
        this.construindoCheckout = true;
        try {
          this.clientSecret = await getCheckoutSession(this.priceSelecionado.id);
          const clientSecret = this.clientSecret;
          if (!this.stripe) {
            this.construindoCheckout = false;
            this.toastErro();
            return;
          }
          await this.$nextTick();
          const checkoutElement = document.querySelector('#checkout');
          if (!checkoutElement) {
            this.construindoCheckout = false;
            this.toastErro();
            return;
          }
          this.checkout = await this.stripe.initEmbeddedCheckout({
            clientSecret,
          });
          this.checkout.mount('#checkout');
          this.construindoCheckout = false;
        } catch (error) {
          this.construindoCheckout = false;
          this.toastErro();
        }
      }
    },
    unmountCheckout() {
      if (this.checkout) {
        this.checkout.destroy();
        this.checkout = null;
      }
    },
    async inicializar() {
      try {
        this.carregandoAssinaturas = true;
        this.carregando = true;
        this.licenca = await obterLicenca();
        this.textoInformeAssinaturaDuplicada = (
          this.licenca.system === 'stripe' ||
      (this.licenca.system !== 'ios' && (this.licenca.system !== 'android' || this.licenca.gratuito === true))
        )
          ? ''
          : this.$t('atencaoAssinaturaOutraPlataforma');
        this.textoAssinatura =
      NomeAssinatura.find((x) => x.productId === this.licenca.productId)?.nome ?? this.$t('assinaturaGratuita');
        this.textoQtdOSFeitasNesseMes = `${this.$t('qtdOSFeitasNesseMes')}: ${this.licenca.quantidadeOsCriada}`;
        if (!this.licenca.renovacaoAutomatica) {
          this.textoStatusAssinatura =
              `${this.licenca.valida
                ? this.$t('expiraEm')
                : this.$t('expiradaEm')}\n  ${toDate(this.licenca.expiraEm)}`;
        } else {
          this.textoStatusAssinatura = this.$t('recorrente');
        }
        this.temAssinaturaStripe =
      this.licenca.valida && this.licenca.system === 'stripe' && this.licenca.gratuito === false;
        this.stripe = await loadStripe(secret.stripe_api_key);
        this.carregando = false;
        this.carregandoAssinaturas = false;
      } catch (error) {
        this.carregandoAssinaturas = false;
        this.toastErro();
      }
    },
    toastErro() {
      useToast().error(this.$t('erroObterDados'));
    },
  },
};
</script>
